import partitionKeys from './partitionKeys';
import metadataForNode from './metadataForNode';

export default function extractNodeLevelData(node) {
  const thisLevelMetadata = metadataForNode(node);
  const { route } = partitionKeys(node);

  return { thisLevelMetadata, route };
}
